<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class=" section" v-on:click="goTo('/parcels_v2')">Paquetes</a>
      <i class="right angle icon divider"></i>
      <a class="active section">Información</a>
    </div>
    <h1 v-if="data" class="ui header"><img class="ui image" src="../../assets/parcels.png">
      <div class="content">Paquete {{ logistic }}: {{ data.user }} <b style="color:red;" v-if="data.blocked">
          BLOQUEADO</b></div>
    </h1>
    <h4 class="ui dividing header">Datos del paquete</h4>
    <div v-if="!data" class="ui active centered inline loader"></div>
    <div v-if="data" class="ui stackable three column divided grid container">
      <div class="row">
        <div class="column">
          <h4 class="ui dividing header">Envío</h4>
          <div class="form ui">
            <div v-if="data.barcode" class="field">
              <label>Barcode</label>
              <div class="ui action input">
                <input type="text" v-model="data.barcode" readonly>
                <button id="seeBarcode" class="ui teal right labeled icon button" v-on:click="seeBarcodeClick()">
                  <i class="barcode icon"></i>
                  Ver
                </button>
              </div>
            </div>
            <div class="field" v-if="showBarcode">
              <div class="barcodePrint" ref="downloadMe">
                <barcode v-bind:value="data.barcode.replace(/\s/g, '')" width="2">
                  Show this if the rendering fails.
                </barcode>
              </div>
              <button id="downloadBarcode" class="eskubia ui teal right labeled icon button"
                v-on:click="downloadBarcodeClick(data.barcode)">
                <i class="download icon"></i>
                Descargar
              </button>
            </div>
            <div v-if="data.barcode_alt" class="field">
              <label>Barcode Alt</label>
              <input type="text" v-model="data.barcode_alt" readonly>
            </div>
            <div v-if="data.multiorder_code" class="field">
              <label>Multiorder Code</label>
              <input type="text" v-model="data.multiorder_code" readonly>
            </div>
            <div v-if="data.refcode" class="field">
              <label>Refcode</label>
              <input type="text" v-model="data.refcode" readonly>
            </div>
            <div v-if="data.service" class="field">
              <label>Servicio</label>
              <input type="text" v-model="data.service" readonly>
            </div>
            <div v-if="data.agencia_cargo" class="field">
              <label>Agencia Cargo</label>
              <input type="text" v-model="data.agencia_cargo" readonly>
            </div>
            <div v-if="data.albaran" class="field">
              <label>Albarán</label>
              <input type="text" v-model="data.albaran" readonly>
            </div>
            <div v-if="data.created" class="field">
              <label>Creado</label>
              <input type="text" v-model="data.created" readonly>
            </div>
            <div v-if="data.in_apt_date" class="field">
              <label>Fecha Operin</label>
              <input type="text" v-model="data.in_apt_date" readonly>
            </div>
            <div v-if="data.sms_send_date" class="field">
              <label>Fecha SMS</label>
              <input type="text" v-model="data.sms_send_date" readonly>
            </div>
            <div v-if="data.lastUpdate" class="field">
              <label>Ultima Act.</label>
              <input type="text" v-model="data.lastUpdate" readonly>
            </div>
          </div>
        </div>
        <div class="column">
          <h4 class="ui dividing header">Máquina</h4>
          <div class="form ui">
            <div v-if="data.apm" class="field">
              <label>Taquilla</label>
              <input type="text" v-model="data.apm" readonly>
            </div>
            <div v-if="data.location" class="field">
              <label>Ubicación</label>
              <input type="text" v-model="data.location" readonly>
            </div>
            <div v-if="data.parcel_id" class="field">
              <label>Parcel id</label>
              <input type="text" v-model="data.parcel_id" readonly>
            </div>
            <div v-if="data.slot_id" class="field">
              <label>Slot id</label>
              <input type="text" v-model="data.slot_id" readonly>
            </div>
            <div v-if="data.pack_size" class="field">
              <label>Tamaño</label>
              <input type="text" v-model="data.pack_size" readonly>
            </div>
            <div v-if="data.dropoff_code" class="field">
              <label>Codigo de entrega</label>
              <input type="text" v-model="data.dropoff_code" readonly>
            </div>
            <div v-if="data.open_code" class="field">
              <label>Codigo de recogida</label>
              <input type="text" v-model="data.open_code" readonly>
            </div>
            <div v-if="data.status" class="field">
              <label>Estado del paquete</label>
              <input type="text" v-model="data.status" readonly>
            </div>
          </div>
        </div>
        <div class="column">
          <h4 v-if="data.nameRemi || data.phoneRemi || data.emailRemi || data.remitente" class="ui dividing header">
            Remitente/Comerciante</h4>
          <div v-if="data.nameOrig || data.phoneRemi || data.emailRemi || data.remitente" class="form ui">
            <div v-if="data.nameRemi" class="field">
              <label>Nombre</label>
              <input type="text" v-model="data.nameRemi" readonly>
            </div>
            <div v-if="data.remitente" class="field">
              <label>Remitente</label>
              <input type="text" v-model="data.remitente" readonly>
            </div>
            <div v-if="data.phoneRemi" class="field">
              <label>Teléfono</label>
              <div class="ui action input">
                <input id="inputEditPhone" type="text" v-model="data.phoneRemi" readonly>
              </div>
            </div>
            <div v-if="data.emailRemi" class="field">
              <label>Email</label>
              <input type="text" v-model="data.emailRemi" readonly>
            </div>
          </div>
          <h4 class="ui dividing header">Destinatario/Cliente</h4>
          <div class="form ui">
            <div v-if="data.name" class="field">
              <label>Nombre</label>
              <input type="text" v-model="data.name" readonly>
            </div>
            <div class="field">
              <label>Teléfono</label>
              <div class="ui action input">
                <input id="inputEditPhone" type="text" v-model="data.phone" readonly>
                <button v-show="!data.blocked" id="editPhone" class="ui teal right labeled icon button"
                  v-on:click="editPhoneClick()">
                  <i class="edit icon"></i>
                  Editar
                </button>
                <div id="editPhoneOK">
                  <div class="ui buttons">
                    <button class="ui red button" v-on:click="editPhoneCancelClick()"><i class="x icon"></i></button>
                    <div class="or"></div>
                    <button class="ui positive button" v-on:click="editPhoneOKClick()"><i
                        class="check icon"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="data.email" class="field">
              <label>Email</label>
              <input type="text" v-model="data.email" readonly>
            </div>
            <div v-if="data.address" class="field">
              <label>Dirección</label>
              <input type="text" v-model="data.address" readonly>
            </div>
            <div v-if="data.cp" class="field">
              <label>Código postal</label>
              <input type="text" v-model="data.cp" readonly>
            </div>
            <div v-if="data.location" class="field">
              <label>Ciudad</label>
              <input type="text" v-model="data.location" readonly>
            </div>
            <div v-if="data.bonos" class="field">
              <label>Bonos</label>
              <input type="text" v-model="data.bonos" readonly>
            </div>
          </div>
          <h4 v-if="data.staff_in || data.staff_out" class="ui dividing header">Staff</h4>
          <div class="form ui">
            <div v-if="data.staff_in" class="field">
              <label>Introducción pedido</label>
              <input type="text" v-model="data.staff_in" readonly>
            </div>
            <div v-if="data.staff_out" class="field">
              <label>Retirada pedido</label>
              <input type="text" v-model="data.staff_out" readonly>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="role !== 'clh'">
      <div v-if="data" class="ui stackable one column divided grid container">
        <div class="row">
          <div class="column">
            <h4 class="ui dividing header">Notificaciones al usuario</h4>
            <div class="ui relaxed divided list">
              <div class="item" v-for="sms in data.smslist" :key="sms.id">
                <img class="ui mini image" src="../../assets/in-apt.png">
                <div class="content">
                  <span class="header">{{ sms.SmsStatus.created }}</span>
                  <div class="description"><b>{{ sms.SmsStatus.from_name }}:</b> <span
                      class="txiki">{{ sms.SmsStatus.text }}</span></div>
                </div>
                <div class="right floated content">
                  <span class="header">{{ sms.SmsStatus.to_phone }}</span>
                  <div class="description">{{ sms.SmsStatus.status }}</div>
                </div>
              </div>
            </div>
            <div v-if="showBtn" class="ui button green" v-on:click="resendSms(data.parcel_id, data.phone)">Re-enviar
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode';
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'parcelInfo_v2',
  props: ['from', 'id'],
  role: null,
  data() {
    return {
      data: null,
      logistic: null,
      showBarcode: false,
      showBtn: true,
    }
  },
  created() {
    this.role = JSON.parse(localStorage.admin).role;
    this.getParcelInfo();
    if (this.role !== 'master' && this.role !== 'admin') {
      this.showBtn = false
    }
  },
  methods: {
    getParcelInfo() {
      hapiickApi().post('/v3/shipments/get-shipment', {
        admin_id: JSON.parse(localStorage.admin).id,
        from: this.from,
        id: this.id
      })
        .then(request => {
          this.parcelInfo(request)
        })
        .catch(
          (request) => {
            this.$swal({
              type: 'error',
              title: 'Error',
              text: 'Error getting parcel info'
            });
            console.log('error getting parcels: ' + request)
          }
        )
    },
    goTo(where) {
      this.$router.push(where)
    },
    parcelInfo(req) {
      this.data = JSON.parse(JSON.stringify(req.data.data.parcel))
      //this.phone = this.data.user.phone

      if (this.data.hasOwnProperty('logistic')) {
        this.logistic = (this.data.logistic === 'D') ? 'Recepción' : 'Emisión';
      }

      if (this.data.status === 'in-apt') {
        if (this.data.pay_code !== undefined && this.data.pay_code && !this.data.pay_date) {
          this.showBtn = false
          return
        }
        if (!this.data.phone) {
          this.showBtn = false
          return
        } else {
          if (this.data.blocked) {
            this.showBtn = false
            return
          } else {
            this.showBtn = true
            return
          }
        }
      } else {
        this.showBtn = false
        return
      }
    },
    resendSms(id, phone) {
      let provider_id = ''; // Si no hay sms previo el provider_id ira vacio
      if (this.data.smslist.length > 0) {
        provider_id = this.data.smslist[0].SmsStatus.provider_id
      }

      hapiickApi().post('/v1/shipments/sms/send-resend', {
        admin_id: JSON.parse(localStorage.admin).id,
        parcel_id: id,
        provider_id: provider_id,
        phone: phone,
        from: this.data.from,
        apt_id: this.data.apt_id,
      })
        .then(request => {
          this.getParcelInfo()
        })
        .catch(() => console.log('error getting parcels'))
    },
    editPhoneClick() {
      document.getElementById("editPhone").style.display = "none";
      document.getElementById("editPhoneOK").style.display = "block";
      document.getElementById('inputEditPhone').removeAttribute('readonly');
      document.getElementById('inputEditPhone').focus()
    },
    editPhoneOKClick() {
      document.getElementById("editPhone").style.display = "block";
      document.getElementById("editPhoneOK").style.display = "none";
      document.getElementById('inputEditPhone').readOnly = true;
      hapiickApi().post('/v2/shipments/edit-phone', {
        admin_id: JSON.parse(localStorage.admin).id,
        user: this.from,
        id: this.id,
        phone: this.data.phone
      }, {
        headers: {
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.token
        }
      })
        .then(request => this.getParcelInfo())
        .catch(() => console.log('error getting parcels'))
    },
    editPhoneCancelClick() {
      document.getElementById("editPhone").style.display = "block";
      document.getElementById("editPhoneOK").style.display = "none";
      document.getElementById('inputEditPhone').readOnly = true;
    },
    seeBarcodeClick() {
      this.showBarcode = !this.showBarcode;
    },
    async downloadBarcodeClick(barcode) {
      const el = this.$refs.downloadMe;
      const options = {
        type: 'dataURL'
      }
      var output = await this.$html2canvas(el, options);
      var link = document.createElement("a");
      link.download = barcode + '.png';
      link.href = output;
      link.click();
    }
  },
  components: {
    'barcode': VueBarcode
  }
}
</script>

<style scoped>
.txiki {
  font-size: 12px;
}

.barcodePrint {
  border-style: solid;
  border-radius: 0.1px;
  border-color: #00f9a9;
  text-align: center;
  z-index: 1;
}

.eskubia {
  top: 10px;
  width: 100%;
}

#editPhoneOK {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Parcels/parcelInfo_v2.vue